import { motion } from "framer-motion";

// Subtle, elegant animated market-inspired background: grid + drawn chart line + data points.
export const MarketBackdrop = ({ className = "" }) => {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {/* faint grid */}
      <div
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.14) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.14) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage: "radial-gradient(ellipse 80% 70% at 50% 40%, black 30%, transparent 100%)",
          WebkitMaskImage: "radial-gradient(ellipse 80% 70% at 50% 40%, black 30%, transparent 100%)",
        }}
      />

      {/* animated chart line */}
      <svg
        className="absolute bottom-0 left-0 w-full h-1/2 opacity-40"
        viewBox="0 0 1200 300"
        preserveAspectRatio="none"
        fill="none"
      >
        <motion.path
          d="M0 240 C 120 200, 180 250, 280 190 S 460 120, 560 160 S 760 60, 880 110 S 1080 40, 1200 90"
          stroke="#C5A059"
          strokeWidth="1.5"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 3, ease: "easeInOut", delay: 0.6 }}
        />
        <motion.path
          d="M0 240 C 120 200, 180 250, 280 190 S 460 120, 560 160 S 760 60, 880 110 S 1080 40, 1200 90 L 1200 300 L 0 300 Z"
          fill="url(#goldFade)"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.14 }}
          transition={{ duration: 2, delay: 2 }}
        />
        <defs>
          <linearGradient id="goldFade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#C5A059" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#C5A059" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>

      {/* floating data points */}
      {[
        { top: "22%", left: "18%", d: 1.2 },
        { top: "38%", left: "72%", d: 1.8 },
        { top: "64%", left: "40%", d: 2.4 },
        { top: "30%", left: "50%", d: 3.0 },
      ].map((p, i) => (
        <motion.span
          key={i}
          className="absolute h-1.5 w-1.5 rounded-full bg-gold"
          style={{ top: p.top, left: p.left }}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: [0, 1, 0.5, 1], scale: 1 }}
          transition={{ duration: 4, delay: p.d, repeat: Infinity, repeatType: "reverse" }}
        />
      ))}
    </div>
  );
};
